import { usePatchDmMessageTriage } from '../../../../hooks/usePatchDmMessageTriage';
import type { DmMessageFrustration, DmMessageUrgency } from '../../../../services/dmMessagesInbox';

interface CurrentTriage {
    urgency: DmMessageUrgency;
    frustration: DmMessageFrustration;
}

// Picking the value already shown is a no-op rather than a write.
export function useTriageSetters(patientId: string, triage: CurrentTriage) {
    const { mutate } = usePatchDmMessageTriage();
    const setUrgency = (urgency: DmMessageUrgency) => {
        if (urgency !== triage.urgency) mutate({ patientId, patch: { urgency } });
    };
    const setFrustration = (frustration: DmMessageFrustration) => {
        if (frustration !== triage.frustration) mutate({ patientId, patch: { frustration } });
    };
    return { setUrgency, setFrustration };
}
